export const ipv4Regex =
  /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){2}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/;

export const ipv6Regex =
  /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^(?:(?=(?:[0-9a-fA-F]{0,4}:){0,7}([0-9a-fA-F]{0,4}:)?(?:(?:25[0-5]|(2[0-4]|1?[0-9])?[0-9])\.?){4}$)([0-9a-fA-F]{0,4}:){0,7}([0-9a-fA-F]{0,4}:)?\b((25[0-5]|(2[0-4]|1?[0-9])?[0-9])\.?){4}\b)$/;

export const domainNameRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
